import styled from 'styled-components';

export const DivAccordionMobile = styled.div`
    position: static;
    top: auto !important;
    left: auto !important;
    background: ${({ isDragging }) => isDragging ? '#faf8f8' : '#fff'};
    padding: 2rem 2rem;
    border-bottom: 1.5px solid rgba(196, 196, 196, 0.4);

    @media (max-width: 691px) {
        padding: 2rem 1rem
    }

    .switch-mobile {
        cursor: pointer;
        display: flex;
        flex-direction: row;
        align-items: center !important;
        h4 {
            margin: 0.25rem 0 0 1rem !important;
            padding: 0;
            font-family: Montserrat;
            font-size: 16px;
            font-weight: 550 !important;
            font-stretch: normal;
            font-style: normal;
            line-height: 1;
            letter-spacing: normal;
            text-align: left;
            color: #2a0709
        }
    }

    .collapsed-div {
        gap: 2rem;
    }

    .buttons {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 1rem;

        button {
            width: 100%;
            outline: none;
            border: none;
            height: 2.5rem;
            border-radius: 2.5rem;
            font-size: 0.7rem;
            font-weight: 550;
            transition: all 0.2s ease-in-out;
        }

        .red {
            background: var(--red-100);
            color: var(--white);

            :hover {
                background: var(--red-200);
            }

            :active {
                background: var(--red-0);
            }
        }

        .white {
            background: var(--white);
            color: var(--red-200);
            border: 1.5px solid var(--red-200);

            :hover {
                background-color: var(--cor-neutra-100);
            }

            :active {
                background-color: var(--cor-neutra-500);
            }
        }
    }

    .texts {
        height: 48px;
        width: 100%;
        max-width: 144px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        span {
            font-family: Montserrat;
            font-size: 1rem;
        }
        .title {
            color: #a49b9b;
            font-weight: 400
        }
        .content {
            color: #2a0709;
            font-weight: 600;
            width: 100%;
            max-width: 144px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis
        }
    }

    .texts-switch {
        height: 56px;
        width: 100%;
        max-width: 144px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        span {
            font-family: Montserrat;
            font-size: 1rem;
        }
        .title {
            color: #a49b9b;
            font-weight: 400
        }
        .content {
            color: #2a0709;
            font-weight: 600;
            width: 100%;
            max-width: 144px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis
        }
    }

    .header-collapse {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        .left {
            display: flex;
            flex-direction: row;
            align-items: center;
            gap: 1rem;
            .prod-img {
                border: 1px solid #dedede;
                opacity: 1;
                filter: grayscale(0);
                transition: all 1s;
                width: 48px;
                height: 48px;
                border-radius: 4px;
                overflow: hidden;
                object-fit: cover;
            }
            .prod-img-gray {
                border: 1px solid #dedede;
                opacity: 0.8;
                filter: grayscale(1);
                transition: all 1s;
                width: 48px;
                height: 48px;
                border-radius: 4px;
                overflow: hidden;
                object-fit: cover;
            }
            .icon-reorder {
                color: #a49b9b;
                width: 1rem;
                height: 1rem;
                font-size: 1rem;
            }
        }

        .right {
            .icon {
                cursor: pointer;
                width: 22px;
                height: 22px;
                .chevron {
                    transition: 0.3s transform;
                    -webkit-transform: ${({ open }) => open ? 'rotateX(180deg)' : 'rotateX(0deg)'};
                    transform: ${({ open }) => open ? 'rotateX(180deg)' : 'rotateX(0deg)'};
                }
            }
        }
    }
`

export const DivAccordion = styled.div`
            padding: 0 0 0 2rem;
            cursor: pointer;
            display: flex;
            flex-direction: row;
            justify-content: left;
            align-items: center;

            @media (max-width: 360px) {
                padding: 0 0 0 1rem;
            }

            h4 {
                padding: 0 !important;
                margin: 0;
                font-family: Montserrat;
                font-size: 16px;
                font-weight: 700;
                font-stretch: normal;
                font-style: normal;
                line-height: 1;
                letter-spacing: normal;
                text-align: left;
                color: #000000;
                overflow: hidden;
                white-space:nowrap;
                text-overflow:ellipsis;
                max-width:50%;
                display:inline-block;
                @media(max-width: 360px) {
                }
            }

            .icon {
                width: 22px;
                height: 22px;
                padding: 0 16px;

                .chevron {
                    transition: 0.3s transform;
                    -webkit-transform: ${({ open }) => open ? 'rotateX(180deg)' : 'rotateX(0deg)'};
                    transform: ${({ open }) => open ? 'rotateX(180deg)' : 'rotateX(0deg)'};
                }
            }
`

export const StyledTbody = styled.tbody`
    position: static;
    top: auto !important;
    left: auto !important;
    cursor: pointer;
    background-color: ${props => (props.isDragging ? '#faf8f8' : '#fff')};
    :hover {
            background-color: #faf8f8
        }
    tr {
        cursor: pointer;
    }
`

export const Container = styled.div`
    -webkit-filter: blur(0px);
    width: 100%;
    height: 100%;
    overflow: visible;
    display: flex;
    background-color: #fff;
    flex-direction: column;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    -webkit-tap-highlight-color: transparent;

    .title-h4 {
        padding-left: 2rem;

        @media (max-width: 360px) {
            padding-left: 1rem;
        }
    }

                        .td-switch {
                            width: 30.90%;
                            div {
                                display: flex;
                                flex-direction: row;
                                justify-content: space-between;
                                .more-button {
                                    cursor: pointer;
                                    height: 32px;
                                    width: 32px;
                                    outline: none;
                                    border: none;
                                    border-radius: 32px;
                                    background-color: transparent;
                                    justify-content: center;
                                    align-items: center;
                                    font-family: Montserrat;
                                    font-size: 16px;
                                    font-weight: 600;
                                    transition: 0.2s;
                                    padding-top: 5px;
                                    margin-right: 32px;

                                    .icon {
                                        color: #a49b9b;
                                        width: 22px;
                                        height: 22px;
                                        align-self: center;
                                    }

                                    /* :hover {
                                        color: #9c1a1f
                                    } */
                                    :active {
                                        background-color: #dedede
                                    }
                                    
                                    /* @media(max-width: 360px) {
                                        width: 100%;
                                    } */
                                } 
                            }
                        }

    .td-drag {
        padding: 0 2rem;
        width: 7.29%;

        @media (max-width: 360px) {
            padding: 0 1rem;
        }
        .icon {
            color: #a49b9b;
            width: 16px;
            height: 16px;
        }
    }

    td {
        width: 30.90%
    }

    .th-drag {
        width: 7.29%;
    }

    .div-invalido {
            width: 95%;
            max-width: 540px;
            overflow: hidden;
            box-sizing: border-box;
            margin-top: 1rem;

            .texto-invalido {
                font-family: Montserrat;
                font-size: 12px;
                font-weight: 600;
                font-stretch: normal;
                font-style: normal;
                line-height: 1.5;
                letter-spacing: normal;
                color: #c42027;
                float: left;
                cursor: default;
            }
        }

    table {
        width: 100%;
        margin: 0;
        margin-bottom: 2rem;
        font-family: Montserrat;
        text-align: left;
        font-size: 16px;
        border: none;
        border-collapse: collapse;
            .button-del {
                    cursor: pointer;
                    border: 0;
                    outline: 0;
                    background-color: transparent;
                        .i-close {
                            padding: 0 2rem;
                            font-size: 19px;

                            @media (max-width: 360px) {
                                padding: 0 0.75rem 0 1rem;
                            }
                    }
                }
        td {
            max-width: 260px;
            color: #2a0709;
            padding: 24px 0;
            padding-right: -32px;
            border: none;
            font-weight: 600;
            border-top: 2px solid #f3f3f3;
            
            span {
                color: #2a0709;
                overflow: hidden;
                white-space:nowrap;
                text-overflow:ellipsis;
                width:75%;
                display:inline-block;
            }
            .switch {
                width: 106px;
                cursor: pointer;
                display: flex;
                flex-direction: row;
                align-items: center;
                @media (max-width: 360px) {
                    align-items: left;
                    width: 55px;
                    flex-direction: column;
                    line-height: 1.5
                }

                h4 {
                    margin: 0;
                    margin-left: 16px;
                    padding: 0;
                    font-family: Montserrat;
                    font-size: 16px;
                    font-weight: 400;
                    font-stretch: normal;
                    font-style: normal;
                    line-height: 1;
                    letter-spacing: normal;
                    text-align: left;
                    color: #2a0709;

                    @media (max-width: 360px) {
                        margin: 0.25rem 0 0 0;
                    }
                }
            }
            .prodImg {
                width: 48px;
                height: 48px;
                border-radius: 4px;
                overflow: hidden;
                object-fit: cover;
            }
        }

        .td-nome {
            cursor: pointer;

            @media (max-width: 360px) {
                padding: 0 0 0 1rem;
            }
        }
        .td-valor {
            cursor: pointer;

            @media (max-width: 360px) {
                padding: 0 1rem 0 0;
            }
        }
        .th-nome {
            @media (max-width: 360px) {
                padding: 0 0 0 1rem;
            }
        }
        .th-valor {
            @media (max-width: 360px) {
                padding: 0 1rem 0 0;
            }
        }
        th {
            font-weight: normal;
            padding: 36px 0;
            padding-right: -32px;
            border: none;
            border-bottom: 2px solid #f3f3f3;
        }
        thead {
            color: #a49b9b;
        }
        tbody {
            tr {
                cursor: pointer;
                :hover {
                    background-color: #faf8f9
                }
            }
        }
}

    p {
        margin: 0;
        padding: 0;
    }

    hr {
        display: block; 
        height: 1px;
        border: 0; 
        border-top: 2px solid #f3f3f3;
        margin: 1em 0; 
        padding: 0;
    }

    .header {
        display: flex;
        flex-direction: column;
        max-width: 560px;
        padding: 2rem;
        padding-top: 3rem;

        @media (max-width: 420px) {
            padding-top: 40px;
            padding-left: 16px;
            max-width: 291px;
        }

        @media (max-width: 600px) {
            padding-left: 16px;
            max-width: 400px;
        }

        img {
            width: 32px;
            height: 32px;
            margin: 0px;
            padding: 0px;
            object-fit: contain;
        }

        h1 {
            font-family: Montserrat;
            font-size: 2rem;
            margin: 0;
            padding: 0;
            padding-top: 2rem;
            font-weight: 700;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.5;
            letter-spacing: normal;
            text-align: left;
            color: #000000;
            @media(max-width: 420px) {
                    font-size: 1.5rem;
                }
        }

        h5 {
            margin: 0;
            padding: 0;
            padding-top: 1.5rem;
            font-size: 1rem;
            font-weight: normal;
            font-family: Montserrat;
            color: #a49b9b;
            line-height: 2;
            max-width: 416px;
        }
    }

    .botao-div {
        display: flex;
        padding: 2rem;
        padding-top: 0.5rem;

        @media (max-width: 360px) {
            padding: 0 1rem 2rem 1rem
        }
            
        .salvar {
            cursor: pointer;
            height: 40px;
            width: 160px;
            background-color: #c32027;
            outline: none;
            border: none;
            border-radius: 20px;
            justify-content: center;
            align-items: center;
            color: #fff;
            font-family: Montserrat;
            font-size: 11px;
            font-weight: 600;
            transition: 0.2s;

            :hover {
                background-color: #9c1a1f
            }

            :active {
                background-color: #d7232c
            }
            @media(max-width: 360px) {
                width: 100%;
            }
        }

        .salvar-branco {
            /* margin-bottom: -56px;  */
            cursor: pointer;
            height: 40px;
            width: 160px;
            background-color: #fff;
            border: 1px solid #c32027;
            outline: none;
            border-radius: 20px;
            justify-content: center;
            align-items: center;
            color: #c32027;
            font-family: Montserrat;
            font-size: 11px;
            font-weight: 600;
            transition: 0.2s;

            :hover {
                background-color: #faf8f8
            }

            :active {
                background-color: #dedede
            }
            @media(max-width: 360px) {
                width: 100%;
            }
        }
    }

    h1 {
        font-family: Montserrat;
        font-size: 2rem;
        margin: 0;
        padding: 0;
        margin-top: 1.5rem;
        font-weight: 700;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.5;
        letter-spacing: normal;
        text-align: left;
        color: #000000;
        @media(max-width: 420px) {
            font-size: 1.5rem;
        }
    }

    h5 {
        margin: 0;
        padding: 0;
        padding-top: 1.5rem;
        padding-left: 2rem;
        font-size: 1rem;
        font-weight: normal;
        font-family: Montserrat;
        color: #a49b9b;
        line-height: 2;
        max-width: 416px;

        @media (max-width: 360px) {
            padding-left: 1rem
        }
    }

    h4 {
        margin: 0;
        font-family: Montserrat;
        font-size: 16px;
        font-weight: 700;
        font-stretch: normal;
        font-style: normal;
        line-height: 1;
        letter-spacing: normal;
        text-align: left;
        color: #000000;
        @media(max-width: 360px) {
        }
    }

    .info {
        padding: 2rem;

        @media (max-width: 360px) {
            padding: 2rem 1rem;
        }
    }

    .obrigatorio {
        padding: 2rem;

        @media (max-width: 360px) {
            padding: 2rem 1rem;
        }

        .options  {
            width: 100%;
            display: flex;
            flex-wrap: wrap;
            justify-content: flex-start;
            align-items: center;
            flex-direction: row;
            padding-top: 2.5rem;
            @media(max-width: 360px) {
                padding-top: 1.5rem;
            }
            .option {
                cursor: pointer;
                margin-right: 16px;
                margin-bottom: 16px;
                border: 2.5px solid #2a0709;
                border-radius: 100px;
                padding: 12px 32px;
                @media(max-width: 360px) {
                        padding: 6px 14px
                    }
                span {
                    font-family: Montserrat;
                    font-size: 16px;
                    font-weight: 700;
                    color: #2a0709;
                    @media(max-width: 360px) {
                        font-size: 13px;
                    }
                }
            }
            .option-selected {
                cursor: pointer;
                margin-right: 16px;
                margin-bottom: 16px;
                background-color: #2a0709;
                border: 2.5px solid #2a0709;
                border-radius: 100px;
                padding: 12px 32px;
                @media(max-width: 360px) {
                        padding: 6px 14px
                    }
                span {
                    font-family: Montserrat;
                    font-size: 16px;
                    font-weight: 700;
                    color: #fff;
                    @media(max-width: 360px) {
                        font-size: 13px;
                    }
                }
            }
        }
    }

    .maxOuExata {
        padding: 0rem 2rem 2rem 2rem;

        @media (max-width: 360px) {
            padding: 2rem 1rem;
        }

        .options  {
            width: 100%;
            display: flex;
            flex-wrap: wrap;
            justify-content: flex-start;
            align-items: center;
            flex-direction: row;
            padding-top: 2.5rem;
            @media(max-width: 360px) {
                padding-top: 1.5rem;
            }
            .option {
                cursor: pointer;
                margin-right: 16px;
                margin-bottom: 16px;
                border: 2.5px solid #2a0709;
                border-radius: 100px;
                padding: 12px 32px;
                @media(max-width: 360px) {
                        padding: 6px 14px
                    }
                span {
                    font-family: Montserrat;
                    font-size: 16px;
                    font-weight: 700;
                    color: #2a0709;
                    @media(max-width: 360px) {
                        font-size: 13px;
                    }
                }
            }
            .option-selected {
                cursor: pointer;
                margin-right: 16px;
                margin-bottom: 16px;
                background-color: #2a0709;
                border: 2.5px solid #2a0709;
                border-radius: 100px;
                padding: 12px 32px;
                @media(max-width: 360px) {
                        padding: 6px 14px
                    }
                span {
                    font-family: Montserrat;
                    font-size: 16px;
                    font-weight: 700;
                    color: #fff;
                    @media(max-width: 360px) {
                        font-size: 13px;
                    }
                }
            }
        }
    }

    .min-max {
        display: flex;
        flex-direction: row;
        padding: 2rem;

        @media (max-width: 360px) {
            flex-direction: column;
            padding: 0 1rem;
        }

        .counter {
            margin-top: 2.5rem;
            display: flex;
            align-items: center;
            justify-content: space-evenly;
            width: 11.5rem;
            height: 5.5rem;
            border-radius:  0.5rem;
            border: 1px solid #dedede;

            @media (max-width: 360px) {
                justify-content: space-around;
                width: 100%;
                height: 4rem;
            }

            span {
                transition: 0.2s;
                font-family: Montserrat;
                font-size: 1rem;
                font-weight: 600;
                color: #1c0506;
            }

            button {
                transition: 0.2s;
                cursor: pointer;
                border: none;
                outline: none;
                background: transparent;

                .icon {
                    font-size: 1.5rem;
                }
            }
        }

        .min {
            display: flex;
            flex-direction: column;
            align-items: left;
            justify-content: center;
            margin-right: 2.5rem;

            @media (max-width: 360px) {
                flex-direction: column;
                margin: 0;
                padding: 1rem 0;
                padding-bottom: 3rem
            }
        }

        .max {
            display: flex;
            flex-direction: column;
            align-items: left;
            justify-content: center;

            @media (max-width: 360px) {
                flex-direction: column;
                margin: 0;
                padding: 1rem 0
            }
        }
    }

    .preco {
        padding: 2rem;

        @media (max-width: 360px) {
            padding: 3rem 1rem;
        }

        .options  {
            width: 100%;
            display: flex;
            flex-wrap: wrap;
            justify-content: flex-start;
            align-items: center;
            flex-direction: row;
            padding-top: 2.5rem;
            @media(max-width: 360px) {
                padding-top: 1.5rem;
            }
            .option {
                cursor: pointer;
                margin-right: 16px;
                margin-bottom: 16px;
                border: 2.5px solid #2a0709;
                border-radius: 100px;
                padding: 12px 32px;
                @media(max-width: 360px) {
                        padding: 6px 14px
                    }
                span {
                    font-family: Montserrat;
                    font-size: 16px;
                    font-weight: 700;
                    color: #2a0709;
                    @media(max-width: 360px) {
                        font-size: 13px;
                    }
                }
            }
            .option-selected {
                cursor: pointer;
                margin-right: 16px;
                margin-bottom: 16px;
                background-color: #2a0709;
                border: 2.5px solid #2a0709;
                border-radius: 100px;
                padding: 12px 32px;
                @media(max-width: 360px) {
                        padding: 6px 14px
                    }
                span {
                    font-family: Montserrat;
                    font-size: 16px;
                    font-weight: 700;
                    color: #fff;
                    @media(max-width: 360px) {
                        font-size: 13px;
                    }
                }
            }
        }
        
    }

    .itens-adicional {
        padding: 2rem 0 0 0;

        @media (max-width: 360px) {
            padding: 3rem 0 0 0;
        }

        h5 {
            padding-bottom: 2rem
        }

        .itens {
            padding: 2rem;
            padding-top: 30px;
            padding-bottom: 2rem;
            display: flex;
            width: 95%;
            flex-direction: row;
            flex-wrap: wrap;
            flex: 0 0 33%;
            align-items:center;
            justify-content: left;
            -webkit-filter: blur(0px);

            @media (max-width: 360px) {
                -webkit-overflow-scrolling: touch;
                overflow-x: auto;
                width: auto;
                padding: 1.875rem 1rem 2rem;
                flex-wrap: nowrap;

                &::-webkit-scrollbar {
                    display: none;
                }
            }

            .item-add {
                background-color: #faf8f9;
                cursor: pointer;
                position: relative;
                align-items: left;
                justify-content: center;
                margin-top: 1rem;
                width: 204px;
                height: 144px;
                display: flex;
                flex-direction: column;
                border-radius: 0.5rem;
                border: 2px dashed #a09c9d;

                @media (max-width: 360px) {
                    flex: 0 0 auto;
                }

                span {
                    font-family: Montserrat;
                    color: #220a0c;
                    font-size: 1rem;
                    font-weight: 400;

                    p {
                        margin: 0;
                        padding: 0;
                    }
                }

                .title {
                    color: #aeaba9;
                    font-size: 0.75rem;
                }

                button {
                    cursor: pointer;
                    position: absolute;
                    top: 1.25rem;
                    right: 1.25rem;
                    border: 0;
                    outline: 0;
                    background-color: transparent;
                        .i-close {
                        font-size: 1.25rem
                    }
                }
            }

            .item {
                cursor: pointer;
                box-sizing:border-box;
                padding: 1rem;
                cursor: pointer;
                position: relative;
                margin-right: 1rem;
                align-items: left;
                justify-content: flex-start;
                margin-top: 1rem;
                width: 204px;
                height: 120px;
                display: flex;
                flex-direction: row;
                border-radius: 0.5rem;
                border: 1px solid #dedede;

                @media (max-width: 360px) {
                    flex: 0 0 auto;
                }

                :hover {
                    border: 1px solid #000000;
                }

                .prodImg {
                    width: 36px;
                    height: 80%;
                    border-radius: 4px;
                    overflow: hidden;
                    object-fit: cover;
                }

                div {
                    display: flex;
                    flex-direction: column;
                }

                .texto {
                    width: 100%;
                    align-items: left;
                    justify-content: space-between
                }

                .foto {
                    height: 100%;
                    align-self: center;
                    justify-content: center;
                    padding-right: 1rem;
                }

                span {
                    width: 80%;
                    font-family: Montserrat;
                    color: #220a0c;
                    font-size: 0.75rem;
                    font-weight: 500;
                    line-height: 1.4;
                    overflow: hidden;
                    white-space:nowrap;
                    text-overflow:ellipsis;
                    width:60%;
                    display:inline-block;
                }

                .title {
                    color: #aeaba9;
                    font-size: 0.75rem;
                }

                button {
                    cursor: pointer;
                    position: absolute;
                    top: 0.75rem;
                    right: 0.35rem;
                    border: 0;
                    outline: 0;
                    background-color: transparent;
                        .i-close {
                        font-size: 19px
                    }
                }
            }
        }

        .modos {
            display: flex;
            padding-top: 40px;
            padding-bottom: 64px;
            padding-left: 2rem;

            @media (max-width: 360px) {
                padding-left: 1rem;
                padding-top: 1.5rem;
                padding-bottom: 2.5rem;
            }

            h4 {
                padding-top: 0;
                font-weight: 500;
                padding-left: 8px;
            }

            .card {
                cursor: pointer;
                display: flex;
                justify-content: center;
                align-items: center;
            }

            .lista {
                cursor: pointer;
                padding-left: 2rem;
                display: flex;
                justify-content: center;
                align-items: center;
            }
        }
    }

    .close {
        position: absolute;
        right: 32px;
        top: 32px;

        @media(max-width: 600px) {
                right: 10px;
                top: 2.5rem;
            }
        
        button {
            background-color: transparent;
            outline: none;
            cursor: pointer;
            border: none;
            align-self: center;
            box-sizing: border-box;

            .i-close {
                vertical-align: middle;
                align-self: center;
                font-size: 36px;
                top: 10px;
                bottom: 10px;
                left: 10px;
                right: 10px;
                color: #c0b7b8 !important;

                @media(max-width: 600px) {
                    font-size: 26px;
                    top: 16px;
                    bottom: 16px;
                    left: 16px;
                    right: 16px;
                }
            }
        }
    }

    .div-input {
        position: relative;
        width: 90%;
        max-width: 663px;
        height: 78px;
        overflow: hidden;
        border-radius: 10px;
        border: 0.25px solid lightgray;
        margin-top: 40px;
        padding: 0;
        box-sizing: border-box;

        @media(max-width: 600px) {
            width: 100%;
            height: 64px;
            align-self: center;
            margin-top: 2.5rem;
            margin-left: 0;
        }
    }

    .div-input-box {
        position: relative;
        width: 90%;
        max-width: 663px;
        height: 152px;
        overflow: hidden;
        border-radius: 10px;
        border: 0.25px solid lightgray;
        margin-top: 40px;
        padding: 0;
        padding-right: 20px;
        padding-left: 20px;
        padding-top: 8px;
        box-sizing: border-box;

        @media(max-width: 600px) {
            height: 64px;
            align-self: center;
            margin-top: 36px;
            margin-left: 0;
        }
    }

    .div-input-focado {
        position: relative;
        width: 90%;
        max-width: 663px;
        height: 78px;
        overflow: hidden;
        border-radius: 10px;
        border: 0.25px solid #1c0506;
        margin-top: 40px;
        padding: 0;
        box-sizing: border-box;

        @media(max-width: 600px) {
            width: 100%;
            height: 64px;
            align-self: center;
            margin-top: 2.5rem;
            margin-left: 0;
        }
    }

    .div-input-focado-box {
        position: relative;
        width: 90%;
        max-width: 663px;
        height: 152px;
        overflow: hidden;
        border-radius: 10px;
        border: 0.25px solid #1c0506;
        margin-top: 40px;
        padding: 0;
        padding-right: 20px;
        padding-left: 20px;
        padding-top: 8px;
        box-sizing: border-box;

        @media(max-width: 600px) {
            height: 64px;
            align-self: center;
            margin-top: 36px;
            margin-left: 0;
        }
    }

    .div-input-error {
        position: relative;
        width: 90%;
        max-width: 663px;
        height: 78px;
        overflow: hidden;
        border-radius: 10px;
        border: 0.25px solid #c32027;
        margin-top: 40px;
        padding: 0;
        box-sizing: border-box;

        @media(max-width: 600px) {
            width: 100%;
            height: 64px;
            align-self: center;
            margin-top: 2.5rem;
            margin-left: 0;
        }
    }

    .div-input-error-box {
        position: relative;
        width: 90%;
        max-width: 663px;
        height: 152px;
        overflow: hidden;
        border-radius: 10px;
        border: 0.25px solid #c32027;
        margin-top: 40px;
        padding: 0;
        padding-right: 20px;
        padding-left: 20px;
        padding-top: 8px;
        box-sizing: border-box;

        @media(max-width: 600px) {
            height: 64px;
            align-self: center;
            margin-top: 36px;
            margin-left: 0;
        }
    }

    .div-input input {
        font-family: Montserrat;        
        font-size: 16px;
        font-weight: 500;
        width: 80%;
        height: 100%;
        color: #1c0506;
        padding-top: 13px;
        border: none;
        outline: none;
        padding-left: 20px;

        @media(max-width: 360px) {
            padding-top: 8px;
        }
    }

    .div-input-box textarea {
        padding: 0;
        resize: none;
        font-family: Montserrat;        
        font-size: 16px;
        font-weight: 500;
        width: 100%;
        height: 100%;
        color: #1c0506;
        padding-top: 2rem;
        margin-bottom: 40px;
        border: none;
        outline: none;
    }

    .div-input-focado input {
        font-family: Montserrat;        
        font-size: 16px;
        font-weight: 500;
        width: 80%;
        height: 100%;
        color: #1c0506;
        padding-top: 13px;
        border: none;
        outline: none;
        padding-left: 20px;

        @media(max-width: 360px) {
            padding-top: 8px;
        }
    }

    .div-input-focado-box textarea {
        padding: 0;
        resize: none;
        font-family: Montserrat;        
        font-size: 16px;
        font-weight: 500;
        width: 100%;
        height: 100%;
        color: #1c0506;
        padding-top: 2rem;
        margin-bottom: 40px;
        border: none;
        outline: none;
    }

    .div-input-error input {
        font-family: Montserrat;        
        font-size: 16px;
        font-weight: 500;
        width: 80%;
        height: 100%;
        color: #c42027;
        padding-top: 13px;
        border: none;
        outline: none;
        padding-left: 20px;

        @media(max-width: 360px) {
            padding-top: 8px;
        }
    }

    .div-input-error-box textarea {
        padding: 0;
        resize: none;
        font-family: Montserrat;        
        font-size: 16px;
        font-weight: 500;
        width: 100%;
        height: 100%;
        color: #c42027;
        padding-top: 2rem;
        margin-bottom: 40px;
        border: none;
        outline: none;
    }

    .div-input label {
        font-family: Montserrat;
        font-weight: 600;
        color: lightgray;
        position: absolute;
        bottom: 20px;
        left: 20px;
        width: 100%;
        height: 100%;
        pointer-events: none;

        @media(max-width: 360px) {
            bottom: 12px;
        }
    }

    .div-input-box label {
        font-family: Montserrat;
        font-weight: 600;
        color: lightgray;
        position: absolute;
        bottom: 94px;
        left: 20px;
        width: 100%;
        height: 100%;
        pointer-events: none;

        @media(max-width: 360px) {
            bottom: 12px;
        }
    }

    .div-input-focado label {
        font-family: Montserrat;
        font-weight: 600;
        color: lightgray;
        position: absolute;
        bottom: 20px;
        left: 20px;
        width: 100%;
        height: 100%;
        pointer-events: none;

        @media(max-width: 360px) {
            bottom: 12px;
        }
    }

    .div-input-focado-box label {
        font-family: Montserrat;
        font-weight: 600;
        color: lightgray;
        position: absolute;
        bottom: 94px;
        left: 20px;
        width: 100%;
        height: 100%;
        pointer-events: none;

        @media(max-width: 360px) {
            bottom: 12px;
        }
    }

    .div-input-error label {
        font-family: Montserrat;
        font-weight: 600;
        color: lightgray;
        position: absolute;
        bottom: 20px;
        left: 20px;
        width: 100%;
        height: 100%;
        pointer-events: none;

        @media(max-width: 360px) {
            bottom: 12px;
        }
    }

    .div-input-error-box label {
        font-family: Montserrat;
        font-weight: 600;
        color: lightgray;
        position: absolute;
        bottom: 94px;
        left: 20px;
        width: 100%;
        height: 100%;
        pointer-events: none;

        @media(max-width: 360px) {
            bottom: 12px;
        }
    }

    .div-input label::after {
        content: "";
        position: absolute;
        left: 0px;
        bottom: 10px;
        height: 100%;
        width: 100%;
        transform: translateX(-100%);
        transition: transform 0.3s ease;
    }

    .div-input-box label::after {
        content: "";
        position: absolute;
        left: 0px;
        bottom: 10px;
        height: 100%;
        width: 100%;
        transform: translateX(-100%);
        transition: transform 0.3s ease;
    }

    .div-input-focado label::after {
        content: "";
        position: absolute;
        left: 0px;
        bottom: 10px;
        height: 100%;
        width: 100%;
        transform: translateX(-100%);
        transition: transform 0.3s ease;
    }

    .div-input-focado-box label::after {
        content: "";
        position: absolute;
        left: 0px;
        bottom: 10px;
        height: 100%;
        width: 100%;
        transform: translateX(-100%);
        transition: transform 0.3s ease;
    }

    .div-input-error label::after {
        content: "";
        position: absolute;
        left: 0px;
        bottom: 10px;
        height: 100%;
        width: 100%;
        transform: translateX(-100%);
        transition: transform 0.3s ease;
    }

    .div-input-error-box label::after {
        content: "";
        position: absolute;
        left: 0px;
        bottom: 10px;
        height: 100%;
        width: 100%;
        transform: translateX(-100%);
        transition: transform 0.3s ease;
    }

    .content-name {
        position: absolute;
        bottom: 8px;
        left: 0px;
        transition: all 0.3s ease;
    }

    .div-input input:focus + .label-name .content-name,
    .div-input input:valid + .label-name .content-name {
        transform: translateY(-150%);
        bottom: 0px;
        font-size: 12px;

        .div-input::after {
            border: none;
        }
    }

    .div-input-box textarea:focus + .label-name .content-name,
    .div-input-box textarea:valid + .label-name .content-name {
        transform: translateY(-150%);
        bottom: 0px;
        font-size: 12px;

        .div-input-box::after {
            border: none;
        }
    }

    .div-input-focado input:focus + .label-name .content-name,
    .div-input-focado input:valid + .label-name .content-name {
        transform: translateY(-150%);
        bottom: 0px;
        font-size: 12px;

        .div-input-focado::after {
            border: none;
        }
    }

    .div-input-focado-box textarea:focus + .label-name .content-name,
    .div-input-focado-box textarea:valid + .label-name .content-name {
        transform: translateY(-150%);
        bottom: 0px;
        font-size: 12px;

        .div-input-focado-box::after {
            border: none;
        }
    }

    .div-input-error input:focus + .label-name .content-name,
    .div-input-error input:valid + .label-name .content-name {
        transform: translateY(-150%);
        bottom: 0px;
        font-size: 12px;

        .div-input-error::after {
            border: none;
        }
    }

    .div-input-error-box textarea:focus + .label-name .content-name,
    .div-input-error-box textarea:valid + .label-name .content-name {
        transform: translateY(-150%);
        bottom: 0px;
        font-size: 12px;

        .div-input-error-box::after {
            border: none;
        }
    }

    .div-input input:focus + .label-name::after,
    .div-input input:valid + .label-name::after {
        transform: translateX(0%);
    }

    .div-input-box textarea:focus + .label-name::after,
    .div-input-box textarea:valid + .label-name::after {
        transform: translateX(0%);
    }

    .div-input-focado input:focus + .label-name::after,
    .div-input-focado input:valid + .label-name::after {
        transform: translateX(0%);
    }

    .div-input-focado-box textarea:focus + .label-name::after,
    .div-input-focado-box textarea:valid + .label-name::after {
        transform: translateX(0%);
    }

    .div-input-error input:focus + .label-name::after,
    .div-input-error input:valid + .label-name::after {
        transform: translateX(0%);
    }

    .div-input-error-box textarea:focus + .label-name::after,
    .div-input-error-box textarea:valid + .label-name::after {
        transform: translateX(0%);
    }

    .div-input button {
        position: absolute;
        right: 15px;
        top: 20px;
        background-color: transparent;
        outline: none;
        cursor: pointer;
        border: none;
        align-self: center;
        box-sizing: border-box;
        font-size: 28px;

        :hover {
            opacity: 0.6;
        }
        .i {
            vertical-align: middle;
        }

        @media(max-width: 590px) {
            font-size: 22px;
            top: 25px;
        }
        @media(max-width: 360px) {
            font-size: 18px;
            top: 20px
        }
    }

    .div-input-focado button {
        position: absolute;
        right: 15px;
        top: 20px;
        background-color: transparent;
        outline: none;
        cursor: pointer;
        border: none;
        align-self: center;
        box-sizing: border-box;
        font-size: 28px;

        :hover {
            opacity: 0.6;
        }
        .i {
            vertical-align: middle;
        }

        @media(max-width: 590px) {
            font-size: 22px;
            top: 25px;
        }
        @media(max-width: 360px) {
            font-size: 18px;
            top: 20px
        }
    }

    .div-input-error button {
        position: absolute;
        right: 15px;
        top: 20px;
        background-color: transparent;
        outline: none;
        cursor: pointer;
        border: none;
        align-self: center;
        box-sizing: border-box;
        font-size: 28px;

        :hover {
            opacity: 0.6;
        }
        .i {
            vertical-align: middle;
        }

        @media(max-width: 590px) {
            font-size: 22px;
            top: 25px;
        }
        @media(max-width: 360px) {
            font-size: 18px;
            top: 20px
        }
    }
`